
import { mapState } from 'vuex';

export default {
  data() {
    return {
    };
  },
  computed: {
    pageData: {
      get() {
        return this.$store.state.page.pageData;
      },
      // set(value) {
      //   this.$store.commit('page/setPageData', { pageData: value })
      // }
    },
    sections: {
      get() {
        return this.$store.state.page.pageData.sections;
      },
      // set(value) {
      //   this.$store.commit('page/setSections', { sections: value })
      // }
    },
    //...mapState('page', ['pageData'])
    seo() {
      return this.$store.state.page.pageInfo.seo;
    }
  },
  mounted() {
    // debugger;
    this.$nextTick(() => {
        // this.$wow.init();      
    })
    
  },
  async fetch() {
    await this.$store.dispatch('page/loadPageData', { id: this.$route.meta.channelId });
    console.log( this.$store.state.page.pageData)
  },
  head() {
    return {
      title: this.$route.meta.title,
      meta: [
      {
        hid: 'title',
        name: 'title',
        content: (this.seo && this.seo.seoTitle) ? this.seo.seoTitle : ''
      },{
        hid: 'description',
        name: 'description',
        content: (this.seo && this.seo.seoDescription) ? this.seo.seoDescription : ''
      },{
        hid: 'keywords',
        name: 'keywords',
        content: (this.seo && this.seo.seoKeywords) ? this.seo.seoKeywords : ''
      },]
    }
  }
};
